import { BatchAddCartFailMessage } from '@/types/mini-cart';
import { ViewMoreMessage } from './view-more-message';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { AddCartFailCode } from '@/types/base';

interface IProps {
  failList: BatchAddCartFailMessage[];
  open?: boolean;
  onClose?: () => void;
  className?: string;
}

export const AddCartFailMessage = ({ failList = [], onClose, open: customOpen, className }: IProps) => {
  const { t } = useLang(NAMESPACE.common);
  const mappingMessage = (resultCode: AddCartFailCode) => {
    switch (resultCode) {
      case '519':
        return t('code.519');
      case '520':
        return t('code.520');
      case '521':
        return t('code.521');
      case '522':
        return t('code.522');
      case '523':
        return t('code.523');
      case '524':
        return t('code.524');
      case '525':
        return t('code.525');
      case '526':
        return t('code.526');
      case '527':
        return t('code.527');
      case '528':
        return t('code.528');
      case '534':
        return t('code.534');
      case '535':
        return t('code.535');
      case '566':
        return t('code.566');
      default:
        return t('add.cart.failed');
    }
  };

  const open = () => {
    if (customOpen !== undefined) {
      return customOpen;
    }
    return failList.length > 0;
  };

  return (
    <ViewMoreMessage
      className={className}
      onClose={onClose}
      open={open()}
      type="warning"
      title={`${t('add.cart.failed')}:`}
      messages={failList.map((item) => {
        const multiLanguageMessage = mappingMessage(item?.resultCode) ?? '';
        const catalogNumber = item?.catalogNumber ? `(${item.catalogNumber})` : '';
        return `${catalogNumber} ${multiLanguageMessage}`;
      })}
    />
  );
};
